export enum PopupAlign
{
    mouseCursor,
    targetNodeTopLeft,
    targetNodeTopRight,
    targetNodeBottomLeft,
    targetNodeBottomRight,
    targetNodeLeftTop
}